// extracted by mini-css-extract-plugin
export default {"content":"Products_content__iFqvn","topBox":"Products_topBox__Aj7O7"};